import { v4 as uuid } from 'uuid';

import type { CreateReference } from '../mapping';
import type { ResourceType } from '../types';

/**
 * Creates a random reference for the supplied resource type
 *
 * @param resourceType
 * @returns
 */
export const createRandomResourceReference = (
  resourceType: ResourceType,
): CreateReference => {
  const id = uuid();
  return {
    reference: `${resourceType}/${id}`,
  };
};
